import { render, staticRenderFns } from "./RsaConfigurazioneAggiornamentoTariffaListComponent.vue?vue&type=template&id=6363c810"
import script from "./RsaConfigurazioneAggiornamentoTariffaListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneAggiornamentoTariffaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports